import styled from '@mui/system/styled';
import { colors } from 'components/theme/constants';

export const MainText = styled('p')({
  fontWeight: 700,
  fontSize: 18,
  color: colors.black,
});
